import { Flex } from '@chakra-ui/react';
import { TopNavBar } from './TopNavBar';
import { Nudges } from '@/components/ats';
import { useApp } from 'app/use-app';
import { useIsMobile } from '@/hooks/use-IsMobile';

const TopNavBarLayout = () => {
  const isMobile = useIsMobile();
  const { isFromAuth } = useApp();
  if (isFromAuth) return null;
  return (
    <Flex flexDir="column" w="100%">
      {!isMobile && <Nudges />}
      <TopNavBar />
    </Flex>
  );
};

export default TopNavBarLayout;
